import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProcurementListingComponent } from './procurement-listing/procurement-listing.component';
import { ProcurementViewComponent } from './procurement-view/procurement-view.component';
import { ProcurementCreateComponent } from './procurement-create/procurement-create.component';
import { ProcurementBulkComponent } from './procurement-bulk/procurement-bulk.component';
import { PreProcurementCreateGuard } from './pre-procurement-create.guard';
import { PreProcurementFeatureGuard } from './pre-procurement-feature.guard';

const routes: Routes = [

  {
    path: '', pathMatch: 'full', redirectTo: 'procurement-listing'
  },
  {
    path: 'procurement-listing',
    component: ProcurementListingComponent,
    canActivate: [PreProcurementFeatureGuard],
  },
  {
    path: 'procurement-view',
    component: ProcurementViewComponent,
    canActivate: [PreProcurementFeatureGuard],
  } ,
  {
    path: 'procurement-create',
    component: ProcurementCreateComponent,
    canActivate: [PreProcurementFeatureGuard, PreProcurementCreateGuard],
  },
  {
    path: 'bulk-upload',
    component: ProcurementBulkComponent,
    canActivate: [PreProcurementFeatureGuard, PreProcurementCreateGuard],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreProcurementRoutingModule { }
